<div id="counter" class="revamped-counter">
  <div class="container py-5 px-lg-5 text-center">

    <!-- Top Heading -->
    <div class="row justify-content-center mb-5" data-scroll>
      <div class="col-12">
        <h2 class="fw-bold counter-heading">
          <i class="fa-solid fa-graduation-cap me-2"></i>
          29+ Years of Excellence
        </h2>
      </div>
    </div>

    <!-- Counters -->
    <div class="row justify-content-center g-4">

      <div class="col-6 col-md-2" data-scroll>
        <div class="counter-box shine" routerLink="/bheem-awardees" style="cursor: pointer;">
          <div class="icon"><i class="fa-solid fa-medal"></i></div>
          <h2 class="count" data-count="5">0</h2>
          <p>Bheem Awardees</p>
        </div>
      </div>

      <div class="col-6 col-md-2" data-scroll>
        <div class="counter-box shine" routerLink="/international-players" style="cursor: pointer;">
          <div class="icon"><i class="fa-solid fa-globe"></i></div>
          <h2 class="count" data-count="51">0</h2>
          <p>International Players</p>
        </div>
      </div>

      <div class="col-6 col-md-2" data-scroll>
        <div class="counter-box shine" routerLink="/national-players" style="cursor: pointer;">
          <div class="icon"><i class="fa-solid fa-award"></i></div>
          <h2 class="count" data-count="442">0</h2>
          <p>National Players</p>
        </div>
      </div>

      <div class="col-6 col-md-2" data-scroll>
        <div class="counter-box shine" routerLink="/state-players" style="cursor: pointer;">
          <div class="icon"><i class="fa-solid fa-people-group"></i></div>
          <h2 class="count" data-count="330">0</h2>
          <p>State Players</p>
        </div>
      </div>

      <div class="col-6 col-md-2" data-scroll>
        <div class="counter-box shine" routerLink="/university-rankers" style="cursor: pointer;">
          <div class="icon"><i class="fa-solid fa-user-graduate"></i></div>
          <h2 class="count" data-count="1267">0</h2>
          <p>University Rankers</p>
        </div>
      </div>

      <div class="col-6 col-md-2" data-scroll>
        <div class="counter-box shine" routerLink="/meritorious-students" style="cursor: pointer;">
          <div class="icon"><i class="fa-solid fa-users-line"></i></div>
          <h2 class="count" data-count="6511">0</h2>
          <p>Meritorious Students</p>
        </div>
      </div>

    </div>
  </div>
</div>